module.exports = __webpack_public_path__ + "img/color-chain-logo.a4578af6.png";